import { Card, CardContent, CardHeader } from '@/app/common/components/Card.tsx'
import { RadioGroup, RadioGroupItem } from '@/shad/ui/radio-group'

export default function DistributionRulesCard() {
  return (
    <Card>
      <CardHeader>
        <div>
          <h3 className="text-base sm:text-lg font-semibold text-gray-900">
            Distribution Rules
          </h3>
          <p className="mt-1 text-sm text-gray-700">
            Enable automatic fund distribution according to predefined rules.
            <br />
            <b>
              Disabling this will require manual distribution of scholarship
              funds.
            </b>
          </p>
        </div>
      </CardHeader>
      <CardContent>
        <div className="relative max-w-sm rounded-md border border-primary/50 bg-primary/5 p-4">
          <div className="absolute right-4 top-4">
            <RadioGroup
              value="sequence_id"
              aria-label="Selected distribution rule"
            >
              <RadioGroupItem checked value="sequence_id" />
            </RadioGroup>
          </div>
          <div className="mb-2 mt-0 text-gray-800">
            <div className="font-semibold">Sort by Sequence ID</div>
            <div className="mt-1 text-sm text-gray-600">
              Will sort and award students based on the sequence ID from the
              lowest to the highest.
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
